import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Register service worker for PWA installability and push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js', {
      scope: '/'
    }).then((registration) => {
      console.log('[PWA] Service worker registered:', registration.scope);
    }).catch((error) => {
      console.warn('[PWA] Service worker registration failed:', error);
    });
  });

  // Listen for service worker messages (e.g., notification clicks)
  navigator.serviceWorker.addEventListener('message', (event) => {
    console.log('[index.tsx] Received message from service worker:', event.data);
    
    // Handle our custom postMessage format
    if (event.data && event.data.type === 'NOTIFICATION_CLICK' && event.data.url) {
      console.log('[index.tsx] Navigating to (custom):', event.data.url);
      window.location.href = event.data.url;
      return;
    }
    
    // Handle Firebase notification-clicked format
    if (event.data && event.data.messageType === 'notification-clicked' && event.data.data?.url) {
      console.log('[index.tsx] Navigating to (Firebase):', event.data.data.url);
      window.location.href = event.data.data.url;
      return;
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

